export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
export class Logger {
    constructor(name) {
        this.name = name;
    }
    static enableDebugLogging() {
        Logger.isDebug = true;
    }
    static disableDebugLogging() {
        Logger.isDebug = false;
    }
    static setCommunicationService(communicationService) {
        Logger.communicationService = communicationService;
    }
    static for(name) {
        return new Logger(name);
    }
    debug(msg, ...args) {
        if (Logger.isDebug) {
            const message = `${new Date().toLocaleString()} DEBUG: [${this.name}]: ${msg}`;
            if (args.length > 0) {
                console.log(message, ...args);
            }
            else {
                console.log(message);
            }
        }
    }
    info(msg, ...args) {
        const message = `${new Date().toLocaleString()} INFO: [${this.name}]: ${msg}`;
        if (args.length > 0) {
            console.log(message, ...args);
        }
        else {
            console.log(message);
        }
        this.sendLogToDevice(LogLevel.INFO, message, ...args);
    }
    warn(msg, ...args) {
        const message = `${new Date().toLocaleString()} WARN: [${this.name}]: ${msg}`;
        if (args.length > 0) {
            console.warn(message, ...args);
        }
        else {
            console.warn(message);
        }
        this.sendLogToDevice(LogLevel.WARN, message, ...args);
    }
    error(msg, ...args) {
        const message = `${new Date().toLocaleString()} ERROR: [${this.name}]: ${msg}`;
        if (args.length > 0) {
            console.error(message, ...args);
        }
        else {
            console.error(message);
        }
        this.sendLogToDevice(LogLevel.ERROR, message, ...args);
    }
    sendLogToDevice(logLevel, msg, ...args) {
        var _a;
        if (((_a = Logger.communicationService) === null || _a === void 0 ? void 0 : _a.isClosed()) === false) {
            let logMessage = msg;
            args.forEach((arg) => {
                if (arg) {
                    logMessage = logMessage.concat(`\n${JSON.stringify(arg)}`);
                }
            });
            Logger.communicationService.sendLog(logLevel, logMessage);
        }
    }
}
Logger.isDebug = false;
//# sourceMappingURL=data:application/json;base64,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